import { Grid, Typography, Button, SvgIconProps } from '@material-ui/core';
import React from 'react';
import { styles } from './styles';
import { NCRBaseButtonProps } from 'src/common/components/base-button/base-button';
import { useTranslation } from 'react-i18next';

interface LoginMenuPanelItemLabelProps {
  className: string;
  code: string | undefined;
}

interface LoginMenuIconProps {
  icon?: (props: SvgIconProps) => JSX.Element;
}

type LoginMenuPanelItemButtonProps = NCRBaseButtonProps;

export interface LoginMenuPanelItemProps {
  key: string;
  label: LoginMenuPanelItemLabelProps;
  subLabel: LoginMenuPanelItemLabelProps;
  button: LoginMenuPanelItemButtonProps;
  icon: LoginMenuIconProps;
}

const LoginMenuPanelItemLabel = ({
  className,
  code,
}: LoginMenuPanelItemLabelProps): JSX.Element => {
  const { t } = useTranslation();
  return <Typography className={className}>{code && t(code)}</Typography>;
};

export const LoginMenuPanelItem = (props: LoginMenuPanelItemProps): JSX.Element => {
  const { key, button, label, subLabel, icon } = props;
  const Icon = icon.icon;
  const classes = styles();
  return (
    <Grid item key={key}>
      <Button {...button}>
        <Grid container>
          <Grid container>
            <Grid
              item
              container
              className={classes.loginMenuButtonTextContainer}
              direction='column'
            >
              <LoginMenuPanelItemLabel {...label} />
              <LoginMenuPanelItemLabel {...subLabel} />
            </Grid>
            {Icon && (
              <Grid item className={classes.loginMenuIconContainer}>
                <Icon />
              </Grid>
            )}
          </Grid>
        </Grid>
      </Button>
    </Grid>
  );
};
